import { useState, type FormEvent } from 'react'
import { supabase } from '../lib/supabase'

/**
 * Magic link. Ersätter v1:s delade lösenord i query-strängen (kravspec §4.3).
 *
 * Svaret är avsiktligt detsamma oavsett om adressen finns eller inte — annars
 * blir inloggningsrutan ett sätt att ta reda på vilka som är med i gänget.
 */
export function Login() {
  const [email, setEmail] = useState('')
  const [sent, setSent] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)

  async function onSubmit(e: FormEvent) {
    e.preventDefault()
    setBusy(true)
    setError(null)

    const { error } = await supabase.auth.signInWithOtp({
      email: email.trim(),
      options: { emailRedirectTo: `${window.location.origin}/auth/callback` },
    })

    setBusy(false)
    if (error) setError(error.message)
    else setSent(true)
  }

  async function withGoogle() {
    setBusy(true)
    setError(null)

    const { error } = await supabase.auth.signInWithOAuth({
      provider: 'google',
      options: { redirectTo: `${window.location.origin}/auth/callback` },
    })

    // Vid lyckat anrop lämnar webbläsaren sidan, så busy nollställs bara vid fel.
    if (error) {
      setError(error.message)
      setBusy(false)
    }
  }

  return (
    <div className="page" style={{ maxWidth: 460 }}>
      <div className="stack">
        <div>
          <p className="eyebrow">Majortipset</p>
          <h1>Logga in</h1>
        </div>

        {sent ? (
          <div className="card stack">
            <div className="notice notice--ok">
              Om adressen finns hos oss ligger en inloggningslänk i inkorgen nu.
            </div>
            <p className="muted">
              Länken gäller en gång och går ut efter en stund. Kolla skräpposten om den
              inte dyker upp.
            </p>
            <button className="link" onClick={() => setSent(false)}>
              Skicka till en annan adress
            </button>
          </div>
        ) : (
          <form className="card stack" onSubmit={onSubmit}>
            <div>
              <label htmlFor="email">E-postadress</label>
              <input
                id="email"
                type="email"
                autoComplete="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="du@exempel.se"
              />
            </div>

            {error && <div className="notice notice--error">{error}</div>}

            <button className="primary" type="submit" disabled={busy || !email.trim()}>
              {busy ? 'Skickar…' : 'Skicka inloggningslänk'}
            </button>

            <p className="muted">
              Inget lösenord. Du får en länk på mejlen som loggar in dig.
            </p>

            <div className="login-divider">
              <span>eller</span>
            </div>

            <button type="button" onClick={() => void withGoogle()} disabled={busy}>
              Fortsätt med Google
            </button>

            <p className="muted">
              Det spelar ingen roll vilket sätt du väljer. Så länge du använder samma
              e-postadress kommer du till ditt vanliga konto med dina lag och resultat
              — du kan byta mellan inloggningslänk och Google när du vill. Det blir
              bara två konton om du använder två olika adresser.
            </p>
          </form>
        )}
      </div>
    </div>
  )
}
